import Emoji from 'common/emoji/Emoji'

import { messages } from '../WidgetMessage'

const Error = () => {
  return (
    <div className="flex justify-center items-center border border-red-500 bg-white rounded py-9 shadow-widget">
      <Emoji symbol="🙀" className="text-5xl text-black mr-8" />
      <p className="w-123 text-red-500">{messages.error}</p>
    </div>
  )
}

export default Error
